import React, { useEffect, useRef, useState } from "react";

import toast from 'react-hot-toast';
import { useNavigate, useParams, useSearchParams } from "react-router-dom";

import api from "../../../api";
import { Button, RenderFormFieldsHOC, SkeletonFormView } from "../../../components";

export const ViewCampaign = () => {
    const [campaignDataLoading, setCampaignDataLoading] = useState(false);
    const [campaignUIConfig, setCampaignUIConfig] = useState(null);
    const [formSubmitClick, setFormSubmitClick] = useState(false);
    const [isFormError, setIsFormError] = useState(false)
    const [campaignData, setCampaignData] = useState(null)
    const [searchParams, setSearchParams] = useSearchParams();
    const [viewMode, setViewMode] = useState(true)
    const [saveDraftLoading, setSaveDraftLoading] = useState(false);
    const [publishLoading, setPublishLoading] = useState(false);
    const [submitButtonClicked, setSubmitButtonClicked] = useState(null)

    const configRef = useRef(null)
    const navigate = useNavigate()

    const params = useParams()

    useEffect(() => {
        if (campaignUIConfig) {
            configRef.current = campaignUIConfig.catalogComponent
            //in this way whenever I am changing the state I can manual trigger config to update and anyways render function call is happening
            setCampaignDataLoading(false)
        }
    }, [campaignUIConfig])

    const getCampaignData = async ({ campaignId }) => {
        try {
            setCampaignDataLoading(true)
            const response = await api.getCampaignById({
                campaignId
            })

            setCampaignUIConfig(response)
            setCampaignDataLoading(false)
        } catch (err) {
            console.log("getCampaignData by id:", err)
            setCampaignDataLoading(false)
            toast.error("Unable to fetch Campaign details", {
                position: "bottom-right"
            })
        }
    }

    useEffect(() => {
        if (params) {
            const { campaignId } = params
            getCampaignData({
                campaignId
            })

        }
    }, [params])

    useEffect(() => {
        if (searchParams) {
            if (searchParams.get("mode") === "view") {
                setViewMode(true)
                setFormSubmitClick(false)
                setSubmitButtonClicked("")
            } else {
                setViewMode(false)
            }
        }
    }, [searchParams])

    useEffect(() => {
        //Handle form submit to api call, currently only for Drafts
        if (!isFormError && formSubmitClick) {
            let status = "DRAFT"
            if (submitButtonClicked === "ATTACH_RULES") {
                status = campaignUIConfig?.catalogInstanceDetails?.catalogState
            }
            else if (submitButtonClicked === "DRAFT") {
                status = "DRAFT"
            }
            else if (submitButtonClicked === "PUBLISH") {
                status = "ACTIVE"
            }
            updateCampaignData({ status })
        }
    }, [formSubmitClick, isFormError, submitButtonClicked])

    const errorCallback = (error) => {
        if (error) {
            // alert(config.keyName + " has error")
            //restrict api calls
            if (!isFormError) { //avoid multiple updates
                setIsFormError(error)
            }
        }
    }

    const updateCampaignData = async ({ status }) => {
        try {
            if (status === "DRAFT") {
                setSaveDraftLoading(true)
            } else if (status === "ACTIVE") {
                setPublishLoading(true)
            }

            const response = await api.updateCampaign({
                dataJson: {
                    catalogComponent: configRef.current,
                    catalogInstanceDetails: {
                        ...(campaignUIConfig.catalogInstanceDetails),
                        catalogState: status
                    }
                }
            })

            if (response) {
                setSaveDraftLoading(false)
                setPublishLoading(false)

                const { catalogInstanceDetails } = response
                if (status === "DRAFT") {
                    toast.success("Saved Campaign to Drafts")
                }
                else if (status === "ACTIVE") {
                    toast.success("Campaign published successfully")
                }
                if (catalogInstanceDetails?.status === "SUCCESS") {
                    if (submitButtonClicked !== "ATTACH_RULES") {
                        navigate(`/campaigns/campaign/${params.campaignId}?mode=view`)
                    } else {
                        navigate(`/campaigns/campaign/attach-rules/campaign/${params.campaignId}?type=${configRef.current?.catalogId?.slice('CAMPAIGN_'.length)}`)
                    }
                }
            }
        } catch (err) {
            setSaveDraftLoading(false)
            setPublishLoading(false)

            let errorMessage = err.response?.data?.errorMessage
            toast.error(errorMessage ? errorMessage : "Unable to save Campaign")
            setFormSubmitClick(false)
        }
    }

    return (
        <div className="w-full h-full overflow-auto px-8 py-3">

            <div className="flex flex-col gap-6 pt-4 px-2">
                {campaignDataLoading && <SkeletonFormView />}

                {!campaignDataLoading && campaignUIConfig && configRef.current &&
                    <>
                        {
                            <RenderFormFieldsHOC
                                config={configRef.current}
                                parent={configRef.current}
                                childIndex={0}
                                sectionId={""}
                                formSubmitClick={formSubmitClick}
                                errorCallback={errorCallback}
                                rerenderFormUI={setCampaignUIConfig}
                                viewMode={viewMode}
                            />
                        }
                    </>
                }
            </div>
            {!campaignDataLoading && campaignUIConfig &&
                <div className="flex flex-col pt-4 px-2">
                    <p>Attached Rule IDs: {campaignUIConfig?.catalogInstanceDetails?.ruleId?.join(",") || "None"} </p>

                    {
                        !viewMode &&
                        <div className="flex justify-end items-center gap-2 mt-2">
                            <Button
                                variant="primary"
                                onClick={() => {
                                    setFormSubmitClick(true)
                                    setSubmitButtonClicked("ATTACH_RULES")
                                    // if (!isFormError) {
                                    //     SaveCampaignToDraft({
                                    //         catalogComponent: configRef.current
                                    //     })
                                    // }
                                }}>
                                Edit Attached Rules
                            </Button>
                            <Button
                                variant="primary"
                                disabled={saveDraftLoading}
                                onClick={() => {
                                    setFormSubmitClick(true)
                                    setSubmitButtonClicked("DRAFT")
                                    //post api call or any error revert back to false
                                }
                                }
                            >
                                Save to Drafts
                            </Button>
                            <Button
                                variant="primary"
                                disabled={publishLoading}
                                onClick={() => {
                                    setFormSubmitClick(true)
                                    setSubmitButtonClicked("PUBLISH")
                                    //post api call or any error revert back to false
                                }
                                }
                            >
                                Publish Campaign
                            </Button>
                        </div>
                    }
                </div>
            }

        </div>
    )
}